module.exports = ".playing-card{\n    background: url('/assets/img/cards.png');\n    display:inline-block;\n}\n\n"